__turbopack_context__.v({
  "absoluteCentered": "video-module-scss-module__0Fd8na__absoluteCentered",
  "aspectRatioPadding": "video-module-scss-module__0Fd8na__aspectRatioPadding",
  "badgeTiming": "video-module-scss-module__0Fd8na__badgeTiming",
  "captionButton": "video-module-scss-module__0Fd8na__captionButton",
  "ccButtonContainer": "video-module-scss-module__0Fd8na__ccButtonContainer",
  "circle": "video-module-scss-module__0Fd8na__circle",
  "container": "video-module-scss-module__0Fd8na__container",
  "controllerContainer": "video-module-scss-module__0Fd8na__controllerContainer",
  "copyright": "video-module-scss-module__0Fd8na__copyright",
  "currentTime": "video-module-scss-module__0Fd8na__currentTime",
  "description": "video-module-scss-module__0Fd8na__description",
  "desktopViewButton": "video-module-scss-module__0Fd8na__desktopViewButton",
  "fullSizePoster": "video-module-scss-module__0Fd8na__fullSizePoster",
  "inlineVideo": "video-module-scss-module__0Fd8na__inlineVideo",
  "inlineVideoContent": "video-module-scss-module__0Fd8na__inlineVideoContent",
  "innerRightContainer": "video-module-scss-module__0Fd8na__innerRightContainer",
  "isModalVideo": "video-module-scss-module__0Fd8na__isModalVideo",
  "modalVideoContainer": "video-module-scss-module__0Fd8na__modalVideoContainer",
  "playButton": "video-module-scss-module__0Fd8na__playButton",
  "playPauseButton": "video-module-scss-module__0Fd8na__playPauseButton",
  "playPauseContainer": "video-module-scss-module__0Fd8na__playPauseContainer",
  "playPauseToggleOverlay": "video-module-scss-module__0Fd8na__playPauseToggleOverlay",
  "positionTranscriptRight": "video-module-scss-module__0Fd8na__positionTranscriptRight",
  "remainingTime": "video-module-scss-module__0Fd8na__remainingTime",
  "rightContainer": "video-module-scss-module__0Fd8na__rightContainer",
  "shortControlBar": "video-module-scss-module__0Fd8na__shortControlBar",
  "staticControlBar": "video-module-scss-module__0Fd8na__staticControlBar",
  "textContainer": "video-module-scss-module__0Fd8na__textContainer",
  "timeDisplay": "video-module-scss-module__0Fd8na__timeDisplay",
  "timeProgressBar": "video-module-scss-module__0Fd8na__timeProgressBar",
  "title": "video-module-scss-module__0Fd8na__title",
  "transcriptFloatRight": "video-module-scss-module__0Fd8na__transcriptFloatRight",
  "transcriptWrapper": "video-module-scss-module__0Fd8na__transcriptWrapper",
  "videoContainer": "video-module-scss-module__0Fd8na__videoContainer",
  "videoContent": "video-module-scss-module__0Fd8na__videoContent",
  "videoControlsContainer": "video-module-scss-module__0Fd8na__videoControlsContainer",
  "videoGroup": "video-module-scss-module__0Fd8na__videoGroup",
  "videoPlayer": "video-module-scss-module__0Fd8na__videoPlayer",
  "videoTiming": "video-module-scss-module__0Fd8na__videoTiming",
  "videoTitle": "video-module-scss-module__0Fd8na__videoTitle",
  "videoTitleContainer": "video-module-scss-module__0Fd8na__videoTitleContainer",
  "volumeButton": "video-module-scss-module__0Fd8na__volumeButton",
  "volumeContainer": "video-module-scss-module__0Fd8na__volumeContainer",
  "volumeControl": "video-module-scss-module__0Fd8na__volumeControl",
  "youtubeVideo": "video-module-scss-module__0Fd8na__youtubeVideo",
});
